import { render, staticRenderFns } from "./DashBanner.vue?vue&type=template&id=646340bb&scoped=true&"
import script from "./DashBanner.vue?vue&type=script&lang=ts&"
export * from "./DashBanner.vue?vue&type=script&lang=ts&"
import style0 from "./DashBanner.vue?vue&type=style&index=0&id=646340bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646340bb",
  null
  
)

export default component.exports